import React, { useEffect } from 'react';
import { FallbackProps, getErrorMessage } from 'react-error-boundary';
import Alert from 'components/V1/Alert/Alert';
import { Text } from '@applatform/design-system';
import { getWithExpiry, setWithExpiry } from 'utils/storage';

const chunkFailedStorageKey = '__chunk_failed__';

export function ErrorFallback({ error }: FallbackProps) {
  // This handles failed lazy loading of a JS/CSS chunk.
  // It's possible that the chunk failed to load due to it no longer existing.
  // To solve this problem, we reload the page to get the latest content.
  // With logic to prevent a reload loop in case it's failing for a different reason.
  useEffect(() => {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    const message = getErrorMessage(error);
    if (message && chunkFailedMessage.test(message)) {
      if (!getWithExpiry(chunkFailedStorageKey)) {
        setWithExpiry(chunkFailedStorageKey, 'true', 10000);
        window.location.reload();
      }
    }
  }, [error]);

  return (
    <Alert status="error" css={{ mb: '$8' }}>
      <Text css={{ mb: '$2' }}>
        Something went wrong. Try refreshing the page.
      </Text>
    </Alert>
  );
}
